// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D1PaeqS","sub-title":"_5D1sd2cT","text-field":"_5D1_y25d","field-container":"_5D2_BBjF","edit-field--not-allowed":"_5D_pKYH3","submit-btn":"_5D3p4p5c"};